<template>
  <span v-if="items.length" class="location-social-handles">
    <template v-for="(identity, index) in items" :key="identity.platform">
      <span v-if="index > 0" class="location-social-handles__sep"> · </span>
      <a v-if="identity.href" class="location-social-handles__item" :href="identity.href" target="_blank" rel="noopener noreferrer" @click.stop>
        <IconEmbedded :name="identity.platform" :size="14" color="#667085" />
        <span>{{ identity.label }}</span>
      </a>
      <span v-else class="location-social-handles__item">
        <IconEmbedded :name="identity.platform" :size="14" color="#667085" />
        <span>{{ identity.label }}</span>
      </span>
    </template>
  </span>
</template>

<script setup lang="ts">
import { computed } from "vue";
import IconEmbedded from "@components/ui/IconEmbedded.vue";
import type { IconName } from "@contracts/IconName";
import type { LocationData } from "@contracts/socialLocations";
import { buildFacebookPageUrl, buildInstagramProfileUrl, buildTikTokProfileUrl } from "@logic/SocialFieldInputCleaner";

interface IdentityItem {
  platform: IconName;
  label: string;
  href: string;
}

const props = defineProps<{
  location?: LocationData | null;
}>();

const items = computed((): IdentityItem[] => {
  const socialSet = props.location?.socialSet;
  if (!socialSet) return [];
  const result: IdentityItem[] = [];
  if (socialSet.instagramHandle) {
    result.push({
      platform: "instagram",
      label: `${socialSet.instagramHandle}`,
      href: buildInstagramProfileUrl(socialSet.instagramHandle),
    });
  }
  if (socialSet.facebookPageName) {
    result.push({
      platform: "facebook",
      label: socialSet.facebookPageName,
      href: buildFacebookPageUrl(socialSet.facebookPageUrl, socialSet.facebookPageId),
    });
  }
  if (socialSet.tikTokHandle) {
    result.push({
      platform: "tiktok",
      label: `${socialSet.tikTokHandle}`,
      href: buildTikTokProfileUrl(socialSet.tikTokHandle),
    });
  }
  return result;
});
</script>

<style scoped lang="scss">
.location-social-handles {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 2px 0;
  color: #667085;
  font-size: 90%;
}
.location-social-handles__item {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: inherit;
  text-decoration: none;
}
a.location-social-handles__item:hover {
  text-decoration: underline;
}
.location-social-handles__sep {
  margin: 0 4px;
}
</style>
